import { render, staticRenderFns } from "./CreditosItem.vue?vue&type=template&id=2e88dcde&scoped=true&lang=pug&"
import script from "./CreditosItem.vue?vue&type=script&lang=js&"
export * from "./CreditosItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88dcde",
  null
  
)

export default component.exports